/*********************************************
Translation example:
  button: {
    search: 'Search'
  },
==>
  button: {
    search: 'Search'
  },
*********************************************/
export default {
  payingText: 'Pagando ...',

  general: {
    change: 'Cambio',
    save: 'Guardar',
    cancel: 'Cancelar',
    or: 'o',
    privacyPolicy: 'Privacidad',
    privacyPolicyLink: '/privacy',
    returnRules: 'Devolución De Productos',
    returnRulesLink: '/returnrules',
    termsOfUse: 'Términos',
    termsOfUseLink: '/terms',
    restaurants: 'Restaurantes',
    restaurantsLink: 'https://www.clickdishes.com/restaurant',
    facebookLink: 'https://www.facebook.com/ClickDishes/',
    twitterLink: 'https://twitter.com/clickdishes',
    instagramLink: 'http://joyaa.ar/',
    wechatLink: 'http://joyaa.ar/',
    agreeButtonText: 'Sí, estoy de acuerdo',
    serverError: 'Lo sientimos, hubo un error del servidor...',
    signin: 'Iniciar sesión',
    confirm: {
      soloOrder: '¿Queres crear un pedido propio?'
    },
    success: {
      orderSent: '¡Pedido enviado con éxito!'
    },
    error: {
      permissionNotAllowed:
        'Perdón, usted no tienes el permiso para acceder a este recurso.',
      nameOnCard: 'Se requiere el nombre en la tarjeta!',
      convertToSoloOrder: 'Lo sentimos, no se pudo convertir a pedido individual.'
    },

    filterText: 'Filtrar',
    specialRequest: 'Requisito especial',
    orderNumber: 'Pedido #',
    okText: 'Ok',
    email: 'Email',
    ptsText: 'pts',
    address: '{NumeroDeLaCalle} {NombreDeLaCalle}, {Ciudad}'
  },
  page: {
    copyright: 'Derechos de autor',
    company: 'JOYAA',
    rightsReserved: 'Todos los derechos reservados.'
  },
  header: {
    signinText: 'Iniciar sesión',
    signupText: 'Registrar',
    signoutText: 'Cerrar sesión',
    accountMenu: {
      updateAccount: 'Actualizar la cuenta',
      orderHistory: 'Historial del pedido',
      rewards: 'Recompensas',
      inviteFriends: 'Recomendar a amigos',
      friends: 'Amigos',
      paymentMethods: 'Método de pago',
      accountText: 'Cuenta',
      help: 'Obtener ayuda',
      helpUrl: 'https://www.clickdishes.com/faq',
      signout: {
        confirmText: '¿Quieres eliminar el pedido reciente?'
      }
    },

    changeLocation: {
      tooltip: 'Cambiar tu ubicación'
    },

    search: {
      tooltip: 'Buscar tienda por nombre',
      closeButtonText: 'Cerrar',
      placeholder: 'Buscar tienda por nombre'
    }
  },
  spinner: {
    text: 'Cargando ...'
  },

  showMore: {
    buttonText: 'Mostrar más ...'
  },

  confirm: {
    yesButtonText: 'Sí',
    noButtonText: 'No',
    cancelButtonText: 'Cancelar',
    titleText: 'Confirmar'
  },

  rating: {
    level45Text: '4.5 & up',
    level40Text: '4.0 & up',
    level35Text: '3.5 & up',
    level30Text: '3.0 & up'
  },
  signin: {
    title: 'Iniciar sesión',
    spinner: {
      text: 'Iniciar sesión ...'
    },
    email: {
      placeholder: 'Correo electrónico',
      validation: 'Correo electrónico requerido'
    },
    password: {
      placeholder: 'Contraseña',
      validation: 'Contraseña requerida'
    },

    signinText: 'Iniciar sesión',

    or: 'O',
    forgetPassword: '¿Olvidaste la contraseña?',
    continueWithFacebook: 'Continuar con Facebook',
    continueWithGoogle: 'Continuar con Google',
    failText: 'Correo electrónico o contraseña inválida',
    button: {
      signin: 'Iniciar sesión con correo electrónico'
    },
    successText: 'Iniciar sesión con éxito',
    social: {
      successText: 'Iniciar sesión con éxito',
      failText: 'No se pudo iniciar sesión con redes sociales. Por favor, inténtalo de nuevo.'
    },
    error: {
      convertAnonymous: 'Lo siento, no se pudo convertir a un pedido anónimo',
      google: 'Error de autenticación de Google',
      failText: 'Correo electrónico o contraseña inválida'
    }
  },

  signout: {
    successText: 'Cerrar sesión con éxito'
  },
  signup: {
    title: 'Registrar',
    or: 'O',
    needAccount: '¿Necesitas una cuenta?',
    signup: 'Registrar',
    signUpWithEmail: 'Registrar con Email',
    signupConditionText1: 'Al crear una cuenta, estás acuerdo con nuestros ',
    signupConditionText2: ' y ',
    signupConditionText3: '',
    signupWithFacebook: 'Registrar con Facebook',
    signupWithGoogle: 'Registrar con Google',
    referralCode: {
      placeholder: 'Código de referencia (opcional)',
      invalidText: 'Código de referencia inválida inválida'
    }
  },

  emailSignup: {
    title: 'Registrar',
    or: 'O',
    buttonText: 'Registrar',
    cancelText: 'Cancelar',
    nextText: 'ioguiente',
    email: {
      placeholder: 'Correo electrónico',
      required: 'Requiere correo electrónico',
      invalid: 'Correo electrónico inválido',
      isTaken: 'Tomando el correo electrónico'
    },
    password: {
      placeholder: 'Contraseña',
      required: 'Requiere contraseña',
      minLength6: 'La contraseña debe tener al menos 6 caracteres'
    },
    confirmPassword: {
      placeholder: 'Confirmar contraseña',
      required: 'Se requiere confirmación de contraseña',
      minLength6: 'La contraseña de confirmación debe tener al menos 6 caracteres'
    },
    firstName: {
      placeholder: 'Nombre',
      required: 'Requiere nombre'
    },
    lastName: {
      placeholder: 'Apellido'
    },

    successText: 'Registración exitosa',
    failText: 'Lo sentimos, no se pudo registrar.',
    phoneNumberExists: 'El número de teléfono ya existe.',
    error: {
      passwordsNotMatched: 'La contraseña no coincide con la contraseña de confirmación.',
      emailExists: '¡El correo electrónico ya exite!'
    }
  },

  socialSignup: {
    title: 'Registrar',
    buttonText: 'Registrar',
    successText: 'Registración exitosa',
    error: {
      signup: 'Lo sentimos, no se pudo registrar. '
    }
  },

  phoneNumberVerifier: {
    countryCode: 'Código de país',
    placeholder: 'Número de teléfono',
    button: {
      sendCode: 'Enviar código',
      verify: 'Verificar'
    },
    sendCodeSuccess: {
      message: 'Ingrese el código de verificación de 5 dígitos enviado a su teléfono.'
    },
    sendCodeFail: {
      message: 'No se envió el código. Inténtalo de nuevo.'
    },
    verificationCode: {
      placeholder: 'Código de verificación'
    }
  },

  forgotPassword: {
    titleText: '¿Olvidaste la contraseña?',
    hintText: 'Ingrese su dirección de correo electrónico para solicitar un restablecimiento de contraseña.',
    buttonText: 'Envíame un restablecimiento de contraseña',
    placeholder: {
      emailAddress: 'CORREO ELECTRÓNICO'
    },
    error: {
      emailInvalid: 'Correo electrónico inválido',
      resetFailed: 'Error al restablecer la contraseña.'
    },
    success: {
      emailSent: 'El enlace de restablecimiento de contraseña fue enviado a su correo electrónico.'
    }
  },

  resetPassword: {
    titleText: 'Restablecer su contraseña',
    buttonText: 'Cambiar tu contraseña',
    placeholder: {
      newPasswordText: 'Nueva contraseña',
      reenterPasswordText: 'Reingrese nueva contraseña'
    },

    error: {
      passwordNotMatch: 'Las contraseñas no coinciden, por favor escribalo de nuevo.',
      passwordLength6: 'La contraseña debe contener 6 caracteres como mínimo.',
      resetFailed: 'Lo sentimos, no se pudo restablecer la contraseña.'
    },
    success: {
      passwordReset: 'Su contraseña ha sido restablecida con éxito'
    }
  },

  home: {
    line1: 'Salite de la fila, ordena con anticipación,',
    line2: 'y recoger con TU COMPRA CERCA.',
    placeholder: 'Introduce tu dirección',
    getApp: 'Obtener la aplicación:'
  },

  addressBar: {
    findFood: 'Encontrar comida',
    locationTrackingNotEnabled: '¡El seguimiento de ubicación no está habilitado!',
    locationTrackingNotAvailable: '¡El seguimiento de ubicación no está disponible! ',
    currentLocationText: 'Ubicación actual',
    vancouverText: 'Ciudad Autónoma de Buenos Aires (CABA)',
    calgaryText: 'Tigre',
    edmontonText: 'Ingeniero Maschwitz',
    marunouchiText: 'Marunouchi',
    shinjukuText: 'Shinjuku',
    toranomonText: 'Toranomon',
    buenosAiresText: 'Ciudad Autónoma de Buenos Aires (CABA)',
    tigreText: 'Tigre',
    ingenieroMaschwitzText: 'Ingeniero Maschwitz',
    input: {
      placeholder: 'Introduce tu dirección para empezar'
    },
    geocode: {
      failText: 'Lo sentimos, la codificación geográfica falló',
      errorText: 'Dirección no encontrada'
    },
    currentLocation: {
      tooltip: 'Usar ubicación actual',
      errorText: 'No es compatible o no está permitido obtener la ubicación actual.'
    }
  },

  restaurants: {
    tooltip: {
      favorite: 'Alternar favorito'
    },
    directionButtonText: 'Dirección',
    minsText: 'minutos',
    filters: {
      buttonText: 'Filtros'
    },
    sorter: {
      buttonText: 'Ordenar por'
    },
    nextOpenTime: {
      closedText: 'Cerrado',
      opensAtText: 'Abre {dayTime}'
    },
    errors: {
      cuisinesError: 'Error al cargar cocinas...',
      currentLocation: 'Lo sentimos, no se pudo establecer la ubicación actual.'
    },
    notFound: "No parece haber ningún restaurante cerca de ti",
    favorite: {
      clicked: '{restaurantName} es tu favorito ahora!',
      canceled: '{restaurantName} ya no es tu favorito!',
      error: 'Lo sentimos, no se pudo cambiar el restaurante favorito.'
    }
  },

  filters: {
    button: {
      applyText: 'Aplicar',
      cancelText: 'Cancelar'
    },
    cuisines: {
      titleText: 'Cocinas'
    },
    ratings: {
      titleText: 'Calificaciones'
    },
    rewardsOnly: {
      titleText: 'Solo recompensas',
      titleText2: 'Solo recompensas'
    },

    favoritesOnly: {
      titleText: 'Solo favoritos',
      titleText2: 'Solo favoritos'
    }
  },

  sorter: {
    button: {
      applyText: 'Aplicar',
      cancelText: 'Cancelar'
    },
    list: {
      restaurantName: 'Nombre del restaurante',
      mostClosest: 'Mas cercano',
      highestRating: 'Calificación más alta',
      highestPrice: 'Precio más alto',
      lowestPrice: 'Precio más bajo '
    }
  },
  restaurant: {
    header: {
      confirmOrderDelete: '¿Está seguro de que desea eliminar el pedido?',
      rating: 'Calificación:',
      ratingLink: 'Sé el/la primero/a en calificar ',
      info: {
        direction: 'Dirección',
        call: 'Llamar',
        hours: 'Horas',
        closeButtonText: 'Cerrar'
      },
      estimations: 'Listo en {estimations} minutos'
    },
    error: {
      deleteOrder: 'Perdón, no se puede eliminar el pedido.',
      createOrder: 'Perdón, no se pude crear el orden.',
      updateDish: 'Perdón, no se pude actualizar el plato.',
      removeDish: 'Perdón, no se puede quitar el plato..',
      addDish: 'Perdón, no se puede agregar el plato.'
    },
    menu: {
      soldOutText: 'Vendido',
      addButtonText: 'Agregar',
      addMoreButtonText: 'Agregar más',
      saveXPointsWithYDolllarText: 'Ahorrar {savings} con {points} puntoss'
    },
    cart: {
      subTotalText: 'Total parcial:',
      checkOutButtonText: 'Pagar la cuenta',
      cartIsEmptyText: 'El carrito esta vacío',
      cartEmptyReminderText: 'Añadir un producto para empezar.',
      specialRequestText: 'Requisito:',
      orderExpiredText: 'El pedido ha caducado y la página se actualizará pronto.',
    },
    bottomCart: {
      viewOrderText: 'Ver pedido'
    },
    signInReminder: {
      signInButtonText: 'Iniciar sesión',
      notSignInButtonText: 'Continuar como invitado/a',
      signInDescription: 'Inicie sesión y realice un pago rápido con la(s) tarjeta(s) de pago guardada(s).',
      signInDescription1: 'Regístrese y gane {subTotal} pts para este pedido.',
      signInDescription2: ' Realice un pago rápido con la(s) tarjeta(s) de pago guardada(s).',
      nextButtonText: 'Siguiente',
      cancelButtonText: 'Cancelar',
      placeholder: 'Ingresa tu nombre (requerido)',
      phoneNumberPlaceholder: 'Ingrese su número de teléfono (requerido)'
    },
    isBusyReminder: {
      isBusyText: 'Es posible que el restaurante no pueda cumplir con su pedido. Lo alentamos a que pruebe otros restaurantes o haga su pedido después de las horas punta.',
      isBusyButtonText: 'Entendido',
      isBusyTitleText: 'Volumen de pedido alto'
    },
    isFoodTruckReminder: {
      isFoodTruckText: '{restaurantname} está en {address} hoy.',
      isFoodTruckText2: '{restaurantname} tiene varias ubicaciones cercanas.</br>Esta ubicación está en {address}',
      isFoodTruckText3: '{restaurantname} está en {address} hoy. Por favor, confirme que desea recoger el pedido aquí.',
      isFoodTruckButtonText: 'Entendido',
      isFoodTruckButtonText2: 'Confirmar',
      isFoodTruckTitleText: 'Ubicación de recogida'
    }
  },
  saveDish: {
    specialRequestInfo: 'El requisito especial debe tener menos de 200 caracteres.',
    specialRequest: '¿Tiene un requisito? Ingrésela aquí.',
    noEnoughPoints: 'No hay suficiente puntos',
    redeemableText: 'Canjeable en tu primera compra',
    signedInUsersOnly: 'Solo usuarios registrados',
    addToOrderButtonText: 'Agregar al pedido',
    updateOrderButtonText: 'Actualizar el pedido',
    removeOrderButtonText: 'Borrar Item',
    cancelButtonText: 'Cancelar',
    signinLinkText: 'Iniciar sesión',
    soldOut: 'Vendido',
    rewards: {
      error: {
        fetchPoints: 'Lo sentimos, no se pudo cargar el saldo de su recompensa.'
      }
    }
  },

  checkBoxGroup: {
    minRequiredText: 'Requerido',
    chooseUpToX:'Elige hasta {maxLimit}',
    chooseAsManyAsYouWouldLike: 'Elige tantos como quieras',
    chooseXtoYoptionsfor: 'Elija las opciones de {minLimit} a {maxLimit} para {categoryName}',
    chooseAtLeastXoptionsfor: 'Elija al menos {minLimit} opciones para {categoryName}',
    chooseExactlyXoptionsfor: 'Elija exactamente {maxLimit} opciones para {categoryName}'
  },
  radioButtonGroup: {
    requiredText: 'Requerido'
  },
  checkout: {
    promoErrorText: 'Lo sentimos, no se pudo obtener el Cupón.',
    promoIsUsedText: 'Perdón, este Cupón ya es usado.',
    promoNotAvailableText: 'Lo sentimos, el Cupón no está disponible.',
    promoExpiredText: 'Lo sentimos, el Cupón ha caducado.',
    promoNotEligibleText:
    'Lo siento, no hay descuento porque su subtotal no es suficiente.',
    payWithCreditCardText: 'Paga con tarjeta de crédito',
    noItemInOrderText: 'No hay elementos en su pedido',
    backToMenuText: 'Volver al menú',
    pleaseEnterCVV: 'Por favor ingrese CVV',
    error: {
      fetchOrder: 'Lo sientimos, no se pudo cargar el pedido.',

      cancelOrder: 'Perdón, no se puede cancelar el pedido.',
      updateDish: 'Perdón, no se puede actualizar el pedido.',
      reorder: 'Perdón, no se puede reordenar',
      removeDish: 'Perdón, no se pude borrar el plato'
    },
    dish: {
      specialRequestText: 'Requisito:'
    },
    summary: {
      subtotalText: 'Total parcial:',
      taxText: 'Impuesto:',
      tipText: 'Propina:',
      discountText: 'Descuento:',
      savingsText: 'Ahorros:',
      totalText: 'Total:',
      rewardsText: 'Recompensas:',
      pointsUsedText: 'Puntos usados:',
      showDetailsText: 'Mostrar detalles',
      hideDetailsText: 'Ocultar detalles',
      pickupTimeText: 'Hora de recogida:',
      cancelOrderButtonText: 'Cancelar el pedido',
      confirmCancelOrdereText: '¿Está seguro de que desea cancelar este pedido?'
    },
    tip: {
      applyButtonText: 'Ok',
      cancelButtonText: 'Cancelar',
      addTipText: 'Agregar propina',
      tip0: 'Sin propina',
      tip10: '10% de propina',
      tip10: '10% de propina',
      tip15: '15% de propina',
      tip20: '20% de promina',
      other: 'Otro'
    },
    pickupTime: {
      ASAP: "Lo ante posible",
    },
    promo: {
      applyingText: 'Aplicando',
      applyButtonText: 'Apliacar',
      dismissButtonText: 'Descatar',
      addPromoCodeText: '¿Tienes un Cupón?',
      offText: 'Apagado',
      promoText: 'Promoción',
      promoText2: 'Recompensa por la recomendación',
      placeholder: 'Código promocional',
      referralRewardApplied: '¡Recompensas de referencia aplicadas!',
      error: {
        notApplied: 'Lo sentimos, no se pudo aplicar el código de promoción.',
        fetchReferalReward: 'Lo sentimos, no se pudo obtener la recompensa por recomendación.'
      },
      reminder: {
        cancelButtonText: 'No, gracias',
        signinLinkText: 'Iniciar sesión',
        signupLinkText: 'Registrar',
        text: 'Obtener el descuento promocional de hoy ya!'
      }
    },
    creditCard: {
      cancelButtonText: 'Cancelar'
    },
    quickPayButton: {
      applePayText: 'Apple Pay',
      googlePayText: 'Google Pay'
    },
    creditCardForm: {
      cardNameText: 'Nombre en la tarjeta',
      cardNumberText: 'Número de la tarjeta',
      expirationDateText: 'Fecha de vencimiento',
      cvcText: 'CVC',
      postalCodeText: 'Código postal',
      postalCodeTextHint: 'A1A 1A1',
      makePaymentText: 'Realizar el pago'
    },
    customTip: {
      applyButtonText: 'Aplicar',
      error: {
        greaterThan0: 'La propina debe ser mayor que cero.',
        numeric: 'Monto de propina inválido'
      }
    }
  },

  stripePayButton: {
    addPayCardText: 'Agregar tarjeta de pago',
    payWithCreditCardText: 'Pagar',
    payWithTheCreditCardText: 'Pagar con {cardType} {last4}',
    tooltips: {
      selectPaymentCardText: 'Seleccione tarjeta de pago',
      addPaymentCardText: 'Añadir tarjeta de pago'
    },
    cards: {
      add: {
        linkText: 'Agregar una nueva tarjeta',
        cardNumberText: 'Número de la tarjeta',
        expirationDateText: 'Fecha de vencimiento',
        cvcText: 'CVC',
        postalCodeText: 'Código postal',
        postalCodeTextHint: 'A1A 1A1',
        addCardButtonText: 'Añadir tarjeta',
        cancelButtonText: 'Cancelar',
        error: {
          add: 'Sorry, card is not added.',
          token: 'Sorry, your payment card info is invalid.'
        }
      },
      list: {
        noCardsFoundText: 'Tarjeta no encontrada',
        tooltips: {
          selectAsDefaultText: 'Seleccione esta tarjeta',
          removeCardText: 'Eliminar esta tarjeta'
        },
        confirmCardDelete: '¿Estás seguro/a que queres eliminar esta tarjeta?'
      }
    }
  },

  account: {
    payment: {
      titleText: 'Métodos de pago'
    },
    update: {
      titleText: 'Altualizar la cuenta',
      successText: 'La información de su cuenta está actualizada.',
      failText: 'Lo sentimos, su cuenta no se puedo actualizar.',
      placeholder: {
        picture: 'Imagen',
        changePicture : 'Cambiar Imagen',
        countryCode: 'Código de país',
        phoneNumber: 'Número de teléfono',
        firstName: 'Nombre',
        lastName: 'Apellido',
        email: 'Email',
        referralCode: 'Código de referencia'
      },
      saveButtonText: 'Guardar',
      cancelButtonText: 'Cancelar',
      editButtonText: 'Cambiar',
      firstName: {
        required: '¡Requiere nombre!'
      }
    },
    orders: {
      titleText: 'Pedidos',
      pastButtonText: 'Pasado',
      currentButtonText: 'Recientes',
      viewReceiptButtonText: 'Ver recibo',
      pickupText: 'Recogido en {pickupDate}',
      rateOrderButtonText: 'Orden de tarifa',
      reorderButtonText: 'Reordenar',
      noOrderFoundText: 'No hay pedido encontrado',
      success: {
        emailSent: 'Correo electrónico enviado con éxito.'
      },
      error: {
        fetchOrders: 'Lo sentimos, no se pudo cargar los pedidos.',
        fetchOrder: 'Lo sentimos, no se pudo cargar el pedido.',
        emailSent: 'Lo sentimos, el correo electrónico no se envió correctamente.',
        rating: 'Lo sentimos, no se pudo calificar este pedido.'
      },
      rating: {
        ratingText: 'Clasificación'
      },
      status: {
        pending: 'Pendiente',
        accepted: 'Aceptado',
        preparing: 'Preparando',
        complete: 'Completo',
        paid: 'Completo',
        rejected: 'Rechazado'
      }
    },

    rewards: {
      titleText: 'Recompensas',
      pointsText: 'Puntos',
      summaryText: 'Resumén',
      earnText: 'Ganar',
      redeemText: 'CanjearTexto',
      rateRestaurant: 'Tarifa Restaurante',
      summary: {
        all: 'Todo',
        earn: 'Ganar',
        redeem: 'Canjear'
      },
      redeem: {
        viewOffersText: 'Ver ofertas ahora',
        descriptionText:
          'Canjear en los restaurantes cercanos y ganar puntos para alimentos y bebidas',
        addressBarPlaceholder: 'Introduce tu ubicación'
      }
    }
  },
  orderInvite: {
    content: '{hostName} te invita a pedir comida en{restaurantName}',
    button: {
      accept: 'Aceptar',
      ignore: 'Ignorar'
    },
    error: {
      acceptOrderInvite: 'Lo sentimos, no se pudo aceptar esta invitación.',
      ignoreOrderInvite: 'Lo sentimos, no se pudo ignorar esta invitación.'
    }
  },
  orderInviteChanged: {
    content: '{hostName} cambió la hora de recogida',
    button: {
      accept: 'OK',
    },
    error: {
      acceptOrderInvite: 'Lo sentimos, no se pudo aceptar esta invitación.',
    }
  },
  join: {
    contentText: 'te invito a pedir comida en',
    yesButtonText: 'Si por su puesto!',
    noButtonText: 'No, Gracias',
    okButtonText: 'Ok',
    error: {
      tokenExpired: 'Lo sentimos, el enlace de unión no es válido o ha caducado.',
      createOrder: 'Lo sentimos, error al unirse al pedido del anfitrión.'
    }
  },

  friends: {
    titleText: 'Amigos',
    newTag: 'Nueva etiqueta',
    header: {
      friendRequests: 'Solicitudes de amistad',
      findFriends: 'Buscar amigos'
    },
    tooltip: {
      addTag: 'Añadir nueva etiqueta'
    },
    button: {
      search: 'Buscar'
    },
    placeholder: {
      search: 'Buscar tus amigos por nombre o etiqueta'
    },

    tabs: {
      friends: 'Amigos',
      add: 'Agregar',
      pending: 'Pendiente'
    },
    addFriend: {
      labelText: 'Invitar amigo',
      inviteesTitle: 'Amigos invitados últimamente',
      placeholder: {
        phoneOrEmail: 'Teléfono o correo electrónico'
      },
      phoneOrEmailNotFound:
        'No se encuentra su amigo en Joyaa. ¿Te gustaría invitarlo/a a Joyaa?',
      success: {
        friendRequestSent: 'Solicitud de amistad enviada con éxito.'
      },
      error: {
        friendRequestSent: 'Lo sentimos, no se pudo enviar la solicitud de amistad.',
        fetchPendingInvites: 'Lo sentimos, no estamos pudiendo recuperar las invitaciones pendientes.'
      }
    },
    referFriend: {
      titleText: 'Invitar amigos',
      descriptionText:
        `¡Invite a sus amigos a Joyaa y ambos recibirán 2000 puntos!`,
      referralCodeText: 'Código de referencia',
      message:
        `¡Debe pedir su próxima comida a través de la aplicación Joyaa!\n` +
        `Ordene con anticipación en lugar de esperar en la fila para el almuerzo.\n` +
        `Registrate con mi código '{referralCode}' y obtenga 2000 puntos.`,
      emailSubjectText: ':Nombre te invita a unirte a Joyaa!'
    },
    error: {
      fetchFriends: 'Lo sentimos, ¡no se pudo cargar los amigos!',
      removeTag: 'Lo sentimos, no se pudo eliminar la etiqueta.',
      unfriend: 'Lo sentimos, no se pudo eliminar el amigo/a correctamente.'
    }
  },

  friendRequests: {
    button: {
      accept: 'Aceptar',
      acceptNow: 'Aceptar',
      ignore: 'Ignorar'
    },
    error: {
      fetchRequests: 'Lo sentimos, ¡no se pudo recibir las solicitudes de amistad!',
      accept: 'Perdón, la solicitud de amistad no pudo ser aceptada.',
      reject: 'Perdón, la solicitud de amistad no puede ser rechazada.'
    }
  },

  findFriends: {
    title: 'Buscar amigos',
    button: {
      connect: 'Conectar',
      remove: 'Borrar',
      cancel: 'Cancelar',
      requestSent: 'Solicitud enviada',
      requestRejected: 'Solicitud rechazada',
      friend: 'Amigo/a'
    },

    placeholder: {
      phoneOrEmail: 'Teléfono o correo electrónico de su amigo/a'
    },

    error: {
      fetchInviteList: 'Lo sentimos, no se pudo cargar la lista de invitados',
      cancelInvite: 'Lo sentimos, no se pudo cancelar tu invitación.',
      sendRequest: 'Lo sentimos, no se pudo enviar la solicitud de amistad.',
      findFriend: 'Lo sentimos, no se pudo encontrar al/a la amigo/a.',
      invalidInput: '¡Teléfono o correo electrónico inválido!',
      notFound: '¡No pudimos encontrar a tu amigo en nuestro sistema!',
    }
  },

  friendDetails: {
    name: 'Nombre',
    email: 'Email',
    displayName: 'Nombre del usuario:',
    tags: 'Etiquetas:',
    confirm: {
      unfriend: '¿Estás seguro/a de que queres dejar de ser amigo/a de {amigo}?'
    },
    error: {
      setDisplayName: '¡Lo sentimos, no se puede cambiar el nombre de usuario!',
      removeTag: 'Lo sentimos, ¡No se puede eliminar la etiqueta!'
    }
  },

  refer: {
    copied: 'Código de referencia copiada!',
    titleText: 'Recomendar a amigos',
    descriptionText:
      `¡Invite a sus amigos a Joyaa y ambos recibirán 2000 puntos!`,
    referralCodeText: 'Código de referencia',
    message:
      `¡Debe pedir su próxima comida a través de la aplicación Joyaa! Order ahead instead of ` +
      `esperando en la fila de almuerzo. Registrate com mi código ':referralCode' ` +
      `obtén $2 de descuento en tu primer pedido.`,
    emailSubjectText: ':Nombre te invitamos a unirte a Joyaa!'
  },

  inviteLink: {
    pickupForFriends: '¿Recoger para amigos?',
    error: {
      serverError: '¡Lo sentimos, no se creó ningún enlace de invitación!',
      signInFirst: 'Por favor, registrate primero'
    },
    modal: {
      title: '¡Invita a tus amigos y gana puntos de recompensa!',
      menu: {
        friends: 'Amigos',
        shareLink: 'Compartir enlace'
      }
    },
    sendLink: {
      title: 'Compartir el enlace',
      button: 'Copiar',
      copied: 'Enlace de invitación copiada.'
    },

    sendInvites: {
      title: {
        invites: 'Amigos para invitar',
        invited: 'Amigos invitados'
      },
      placeholder: {
        search: 'Ingrese el nombre o la etiqueta del amigo/a'
      },
      button: 'Invitar',
      success: {
        sendOrderInvites: '¡Pedidos de invitaciones enviado con éxito!'
      },
      error: {
        fetchOrderInvites: 'Lo sentimos, no se pudo cargar las invitaciones del pedido.',
        sendOrderInvites: 'Lo sentimos, no se pudo enviar las invitaciones de pedidos.',
        fetchFriends: 'Lo sientimos, no se pudo cargar los amigos.'
      }
    }
  },
  joinLink: {
    error: {
      createLink: '¡Lo sentimos, no se pudo crear el enlace para unirse al pedido!'
    }
  },
  orderStatus: {
    title: {
      normalOrder: 'Estado del pedido',
      groupOrder: 'Recoger por amigo'
    },
    confirm: {
      cancelOrder: '¿Está seguro de que desea cancelar este pedido?',
      hostOrderCanceled:
      "El pedido del anfitrión está cancelado. ¿Te gustaría cancelar su pedido o continuar como un pedido individual?",
      yesButtonText: 'Cancelar orden',
      noButtonText: 'Continuar aparte'
    },

    button: {
      acceptOrder: 'Aceptar Pedido',
      rejectOrder: 'Rechazar Pedido',
      cancelOrder: 'Cancelar Pedido',
      emailReceipt: 'Recibo de correo electrónico'
    },
    success: {
      acceptOrder: '¡El restaurente aceptó el pedido!',
      rejectOrder: '¡El restaurante rechazó el pedido!',
      cancelOrder: 'El pedido fue cancelado con éxito.',
      emailReceipt: 'Recibo enviado para ti'
    },
    error: {
      fetchOrder: 'Lo sientimos, no se pudo cargar el estado del pedido.',
      acceptOrderError: '¡Lo sentimos, este pedido no fue aceptada!',
      rejectOrderError: '¡Lo sentimos, este pedido no ha sido rechazado!',
      cancelOrder: 'Lo sentimos, este pedido no se puede cancelar.',
      emailReceipt: 'Lo sentimos, no se pudo enviar el recibo por correo electrónico.'
    },
    step: {
      waitForRestaurantConfirm:
        'Pedido enviado. Esperando confirmación del restaurante...',
      orderRejected: 'Perdón, tu pedido fue rechazado.',
      foodPrepared: 'Tu comida está siendo preparada....',
      pickup:
        'Tu comida está lista. Dirígete al mostrador de recogida del restaurante con el código ({shortCode}).'
    },
    guestStep: {
      waitForHost: 'Pedido enviado. Esperando a que el restaurante acepte el pedido.',
      foodPrepared: 'Tu comida está siendo preparada....',
      pickup: 'Tu comida está lista. Te lo entrgará {host}.'
    }
  },
  verifyEmail: {
    spinner: 'Verificar el correo electrónico ... ',
    error: {
      invalidCodeOrEmail: 'Lo sientimos, código o correo electrónico inválido.'
    },
    success: {
      verified: 'El correo electrónico está verificado. ¡Gracias!'
    }
  },

  info: {
    titleText: 'Info'
  },

  feedback: {
    placeholder: '¿Qué podemos hacer para facilitar tu uso?',
    button: {
      send: 'Enviar',
      cancel: 'Cancelar'
    },
    success: 'Gracias, hemos recibido sus comentarios.',
    error: 'Lo sentimos, no pudimos recibir sus comentarios.'
  },
  PRICE: '{precio, número, moneda}' 
};
